import React from 'react';
import { empty } from '../../../utils';

const FrontCanvas = React.memo((props) => {
    if (props.apparelItem == null) {
        return null;
    }

    let bullet1 = null;
    if (props.apparelItem.bullet1) {
        bullet1 = <li>{props.apparelItem.bullet1}</li>;
    }

    let bullet2 = null;
    if (props.apparelItem.bullet2) {
        bullet2 = <li>{props.apparelItem.bullet2}</li>;
    }
    
    let bullet3 = null;
    if (props.apparelItem.bullet3) {
        bullet3 = <li>{props.apparelItem.bullet3}</li>;
    }
    
    let bullet4 = null;
    if (props.apparelItem.bullet4) {
        bullet4 = <li>{props.apparelItem.bullet4}</li>;
    }
    
    let bullet5 = null;
    if (props.apparelItem.bullet5) {
        bullet5 = <li>{props.apparelItem.bullet5}</li>;
    }
    
    let bullet6 = null;
    if (props.apparelItem.bullet6) {
        bullet6 = <li>{props.apparelItem.bullet6}</li>;
    }
    
    let bullet7 = null;
    if (props.apparelItem.bullet7) {
        bullet7 = <li>{props.apparelItem.bullet7}</li>;
    }
    
    let bullet8 = null;
    if (props.apparelItem.bullet8) {
        bullet8 = <li>{props.apparelItem.bullet8}</li>;
    }

    let imageUrl = require('./../images/no-image.jpg');
    if (props.apparelItem.image_url && props.apparelItem.image_url != null && props.apparelItem.image_url !== '' && props.apparelItem.image_url !== '-') {
        imageUrl = props.apparelItem.image_url;
    }
    if (parseInt(props.apparelItem.id) === 125) {   // UTH Unisex T-Shirt
        imageUrl = 'https://ac-ut-health.s3.amazonaws.com/apparel-images/uth-tshirt-orange.jpg';
        if (!empty(props.variables.uth_unisex_shirt_color)) {
            let shirtColorOption = parseInt(props.variables.uth_unisex_shirt_color);
            if (shirtColorOption === 1) {
                imageUrl = 'https://ac-ut-health.s3.amazonaws.com/apparel-images/uth-tshirt-white.jpg';
            } else if (shirtColorOption === 2) {
                imageUrl = 'https://ac-ut-health.s3.amazonaws.com/apparel-images/uth-tshirt-black.jpg';
            } else if (shirtColorOption === 3) {
                imageUrl = 'https://ac-ut-health.s3.amazonaws.com/apparel-images/uth-tshirt-navy.jpg';
            } else if (shirtColorOption === 4) {
                imageUrl = 'https://ac-ut-health.s3.amazonaws.com/apparel-images/uth-tshirt-orange.jpg';
            }
        }
    }

    let colorRow = null;
    if (parseInt(props.apparelItem.logic_version) === 2) {
        colorRow = <div className="color-row"><span className="label">Color:</span> {props.apparelItem.color}</div>
    }

    return (
        <div className="front-canvas-container">
            <h5>Preview</h5>
            <div className="preview-image">
                <img src={imageUrl} alt="Apparel" />
            </div>
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> {props.apparelItem.name}</div>
                {colorRow}
                <div className="description-list">
                    <span className="label">Description:</span> {props.apparelItem.description}
                    <ul>
                        {bullet1}
                        {bullet2}
                        {bullet3}
                        {bullet4}
                        {bullet5}
                        {bullet6}
                        {bullet7}
                        {bullet8}
                    </ul>
                </div>
            </div>
        </div>
    );
});

FrontCanvas.propTypes = {

}

export default FrontCanvas;
